import Icon from './Icon.jsx';

// ─── Fan Owl: conversations by channel ───────────────────────────────────────
// Website vs WhatsApp conversations: unique fans, chats (one fan's messages on
// one day), messages, and the per-fan / per-chat ratios. Cards stack on a phone.
// Two homes: Fan Owl → Reports (where the cards also filter the conversation
// list) and the Conversations page's "What fans are asking the Owl" panel
// (2026-10-26 — the channel numbers belonged beside the themes, not only on
// the report). `channels` is the insights route's { web, whatsapp, total }.

const small = { fontSize: 11.5, color: 'var(--muted)', margin: '2px 0 4px' };

export function Channels({ channels, onPick }) {
  if (!channels) return null;
  const rows = [['web', 'web', 'Website'], ['whatsapp', 'chat', 'WhatsApp'], ['total', 'list', 'Total']];
  const cell = (label, v) => (
    <div style={{ minWidth: 64 }}>
      <div style={{ fontSize: 17, fontWeight: 700 }}>{v || 0}</div>
      <div style={{ fontSize: 11, color: 'var(--muted)' }}>{label}</div>
    </div>
  );
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 8, marginTop: 6 }}>
        {rows.map(([k, icon, label]) => {
          const c = channels[k] || {};
          return (
            <button key={k} type="button" onClick={() => onPick && onPick(k)} title="See these conversations"
              style={{ textAlign: 'left', font: 'inherit', color: 'inherit', cursor: onPick ? 'pointer' : 'default', border: '1px solid var(--hairline)', borderRadius: 10, padding: '10px 12px', background: k === 'total' ? 'var(--surface-2, transparent)' : 'transparent' }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}><Icon name={icon} size={15} /> {label}</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 14px' }}>
                {cell('Unique fans', c.users)}
                {cell('Chats', c.chats)}
                {cell('Messages', c.messages)}
                {cell('Chats / fan', c.chatsPerUser)}
                {cell('Msgs / chat', c.messagesPerChat)}
              </div>
            </button>
          );
        })}
      </div>
      <p style={{ ...small, marginTop: 6 }}>
        Counted from fans' own messages. A <b>fan</b> is one browser (website) or one phone number (WhatsApp); a <b>chat</b> is one fan's conversation on one day — so a fan who comes back tomorrow counts as a second chat.
      </p>
    </>
  );
}
